module.exports = "./app-dist/templates/technology.component.03d3efc21317a564e906a0f77d1ca89f.html";